import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "unit",
	"data-name": "unit",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 7.76,
			y: 1.39,
			width: 8.49,
			height: 21.21,
			transform: "translate(12 28.97) rotate(-135)"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 18.66,
			y1: 11,
			x2: 16.54,
			y2: 8.88
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 15.83,
			y1: 13.83,
			x2: 14.41,
			y2: 12.41
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 13,
			y1: 16.66,
			x2: 10.88,
			y2: 14.54
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 10.17,
			y1: 19.49,
			x2: 8.76,
			y2: 18.07
		})
	]
});
const ForwardRef = forwardRef(SvgUnit);
export default ForwardRef;
